export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gray-900"
    >
      {/* Top Navigation Strip */}
      <div className="absolute top-0 left-0 right-0 z-20 bg-gray-900/80 backdrop-blur-sm border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Brand Name */}
            <div className="flex items-center">
              <h1 className="text-xl lg:text-2xl font-bold tracking-wide text-white" style={{ fontFamily: '"Montserrat", "Helvetica Neue", Arial, sans-serif' }}>
                BlecInk
              </h1>
            </div>
            
            {/* Right Side Navigation */}
            <div className="flex items-center gap-6 lg:gap-8">
              <span className="text-gray-300 text-sm lg:text-base font-medium">HOME</span>
              <button 
                onClick={scrollToContact}
                className="bg-teal-600 hover:bg-teal-700 text-white px-4 lg:px-6 py-1.5 lg:py-2.5 rounded-lg text-xs lg:text-sm font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Kontaktieren Sie Uns
              </button>
            </div>
          </div>
        </div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 pt-32 pb-20">
        <div className="text-center">
          <h2 className="text-5xl md:text-7xl font-bold mb-6 text-white leading-tight">
            Mehr Wachstum, Mehr Umsatz, Mehr Kunden.<br />
            <span className="text-teal-400">Garantiert</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-4xl mx-auto leading-relaxed">
            Sie konzentrieren sich auf Ihr Kerngeschäft, wir kümmern uns ums Marketing. Gemeinsam gestalten wir die Zukunft Ihres Unternehmens.
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button 
              onClick={() => document.getElementById('marketing-promise')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white px-10 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-teal-500/25 cursor-pointer whitespace-nowrap"
            >
              Unser Versprechen
            </button>
            <button 
              onClick={() => document.getElementById('ki-solutions')?.scrollIntoView({ behavior: 'smooth' })}
              className="border-2 border-white text-white hover:bg-white hover:text-gray-900 px-10 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              KI Lösungen
            </button>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-6 flex items-center justify-center text-gray-400">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}
